import React from "react";
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import { CONFIG, CONFIG_UTIL } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import utilManagement from '../../../../apis/utilManagement';
import { ArrowBackIosOutlined, Image } from "@material-ui/icons";


import logo_eduprime from "./assets/logo_eduprime.png";
import logo_uss from "./assets/uss.png";
// import './assets/index.css';
// import './assets/report_snmptn_2.css';

class FormReporting extends React.Component{
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            alertShow : false,
            resMessage : null,
            dataSiswa : {},
        };
    }

    /* componentDidMount(){
        this.setState({
            dataSiswa : this.props.dataSiswa, 
        })
        console.clear();
        console.groupCollapsed('FORM NILAI SNMPTN IN');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();      
        // this.fetchReportSiswa();
    }

    handleBack(){
        this.props.handleBack();
    }

    handleOffFeching(){
        this.props.handleOffFeching();
    }

    handleOnFeching(){
        this.props.handleOnFeching();
    }

    fetchReportSiswa = async () =>{
        // console.clear();

        const dataForm = await utilManagement.post(CONFIG_UTIL.SNMPTN_FETCH_REPORT_SISWA,{
            ['ID_SEKOLAH']: this.props.account.idSekolah,
            ['ID_SISWA']: this.props.dataSiswa.idSiswa,
            ['ID_KELAS']: this.props.idKelas,
        }).catch (function(error){
        })
        console.log(this.props)

        this.handleOffFeching();

    } */

    render(){
        return(
            <div class="solid"> 
                <div class="row">
                    <div class="col-md-12">
                     
                    </div>
                </div>
                <br></br>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(FormReporting);